import { useEffect, useMemo } from 'react';
import { applyCustomTheme, removeCustomTheme, applyCustomLayout, removeCustomLayout } from '../themeCustomization';

import { TEST_CUSTOM_THEME, TEST_CUSTOM_LAYOUT } from 'constants/customThemeConfig';
import { useConfig } from 'utils/hooks/useConfig';

export const useCustomTheme = () => {
  const {
    config: { isCustomDesign, partnerId },
  } = useConfig();

  const customTheme = isCustomDesign ? TEST_CUSTOM_THEME : null;
  const customLayoutClass = isCustomDesign ? TEST_CUSTOM_LAYOUT : null;
  const hasCustomTheme = isCustomDesign;

  const hasCustomLayout = useMemo(() => {
    return Boolean(customLayoutClass);
  }, [customLayoutClass]);

  useEffect(() => {
    if (hasCustomTheme) {
      applyCustomTheme(customTheme, partnerId);
    }

    return () => {
      if (hasCustomTheme) {
        removeCustomTheme();
      }
    };
  }, [hasCustomTheme, customTheme, partnerId]);

  useEffect(() => {
    if (hasCustomLayout) {
      applyCustomLayout(customLayoutClass);
    }

    return () => {
      if (hasCustomLayout) {
        removeCustomLayout(customLayoutClass);
      }
    };
  }, [hasCustomLayout, customLayoutClass]);
};
